import { nonDefaultPartial } from "./object";
export const CROSSLINK = 'crosslink';
export const buildParams = (params)=>{
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach((param)=>{
        let [key, value] = param;
        if (Array.isArray(value)) {
            value.forEach((item)=>searchParams.append(key, String(item)));
        } else if (value instanceof Date) {
            searchParams.set(key, value.toISOString());
        } else if (typeof value === 'number' || typeof value === 'string') {
            searchParams.set(key, String(value));
        } else if (value) {
            throw new Error(`Unsupported parameter type "${typeof value}" for key "${key}". Value: ${value}`);
        }
    });
    return searchParams;
};
export const buildUrlWithParams = (params)=>{
    const url = new URL(window.location.href);
    url.search = buildParams(params).toString();
    return url;
};
/** Returns a URL search string containing only params that differ from defaults. */ export const nonDefaultSearchParams = (params, defaults)=>{
    const diff = nonDefaultPartial(params, defaults);
    const url = buildUrlWithParams(diff);
    return url.search;
};
export const addParamsToUrl = function(params) {
    let addHistory = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const url = buildUrlWithParams(params);
    addHistory ? window.history.pushState({}, '', url.toString()) : window.history.replaceState({}, '', url.toString());
};
const rebuildParams = (url, params)=>`${url.pathname}${params.toString() ? '?' + params.toString() : ''}${url.hash}`;
export const removeSingleParamFromUrl = (key)=>{
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.delete(key);
    // Update the URL without reloading the page
    const newUrl = rebuildParams(url, params);
    window.history.replaceState({}, '', newUrl);
};
export const removeParamsFromUrl = (keysToRemove)=>{
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    Object.keys(keysToRemove).forEach((key)=>params.delete(key));
    // Update the URL without reloading the page
    const newUrl = rebuildParams(url, params);
    window.history.replaceState({}, '', newUrl);
};
export const paramsContainAny = (keys)=>{
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    return keys.some((key)=>params.has(key));
};
export const paramsContainAnyFrom = (template)=>paramsContainAny(Object.keys(template));
export const paramsContain = (key)=>paramsContainAny([
        key
    ]);
/**
 * Parses URL query parameters into an object.
 * @param defaults The default values to use if a parameter is not present in the URL.
 * @param template An optional template object that defines the expected structure and types of the
 *                 parameters. If not provided, `defaults` will be used.
 * @returns An object containing the parsed query parameters, with missing parameters filled in
 *          with default values.
 */ export const parseParamsFromUrl = function(defaults) {
    let template = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaults;
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const result = {
        ...defaults
    };
    Object.entries(defaults).forEach((param)=>{
        let [key, defaultValue] = param;
        const value = params.get(key);
        const templateValue = template[key];
        if (value !== null) {
            if (templateValue instanceof Date) {
                // Parse dates
                const date = new Date(value);
                result[key] = isNaN(date.getTime()) ? defaultValue : date;
            } else if (Array.isArray(templateValue)) {
                // Parse arrays (get all values for the key)
                result[key] = params.getAll(key);
            } else if (typeof templateValue === 'number') {
                // Parse numbers
                result[key] = isNaN(Number(value)) ? defaultValue : Number(value);
            } else if (typeof templateValue === 'boolean') {
                // Parse booleans
                result[key] = value === 'true';
            } else {
                // Assume string or other types
                result[key] = value;
            }
        } else {
            // Use the default value if no query parameter exists
            result[key] = defaultValue;
        }
    });
    return result;
};
